import logo from './logo.svg';
import './App.css';
import Landingpage from './Landingpage/Landingpage';


function App() {
  
  return (
    <div>
      <Landingpage />
    </div>
  );
}

export default App;
